"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePidgetState = void 0;
var react_1 = require("react");
var PidgetContext_1 = require("./PidgetContext");
var usePidgetState = function () {
    var context = (0, react_1.useContext)(PidgetContext_1.PidgetContext);
    if (context === null) {
        throw new Error("usePidgetState must be used within a PidgetProvider");
    }
    var _a = (0, react_1.useState)(context.pidget.state), internalPidgetState = _a[0], setInternalPidgetState = _a[1];
    var setPidgetState = (0, react_1.useCallback)(function (state) {
        setInternalPidgetState(state);
    }, []);
    (0, react_1.useEffect)(function () {
        context.pidget.setState(internalPidgetState);
    }, [context.pidget, internalPidgetState]);
    return [internalPidgetState, setPidgetState];
};
exports.usePidgetState = usePidgetState;
